import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {EStorageKeys} from 'src/constants';
import {listenerMiddleware} from 'src/models';

import {TFilters} from './definitions';

type TState = {
  filters: TAnyObject;
  supportFilters: TAnyObject;
};

const initialState = (): TState => {
  const rememberedFilters = sessionStorage.getItem(EStorageKeys.MESSAGE_MATCHERS_FILTERS);
  const rememberedFiltersSupport = sessionStorage.getItem(
    EStorageKeys.MESSAGE_MATCHERS_FILTERS_SUPPORT,
  );

  return {
    filters: rememberedFilters ? JSON.parse(rememberedFilters) : {},
    supportFilters: rememberedFiltersSupport ? JSON.parse(rememberedFiltersSupport) : {},
  };
};

const messageMatchersSlice = createSlice({
  name: 'messageMatchers',
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<TFilters>) {
      state.filters = action.payload;
    },
    setSupportFilters(state, action: PayloadAction<TFilters>) {
      state.supportFilters = action.payload;
    },
  },
});

export const {setFilters: setFiltersAction, setSupportFilters: setSupportFiltersAction} =
  messageMatchersSlice.actions;

export const selectFilters = (state: TRootState) => state.messageMatchers.filters as TFilters;
export const selectSupportFilters = (state: TRootState) =>
  state.messageMatchers.supportFilters as TFilters;

listenerMiddleware.startListening({
  actionCreator: setFiltersAction,
  effect: (action) => {
    sessionStorage.setItem(EStorageKeys.MESSAGE_MATCHERS_FILTERS, JSON.stringify(action.payload));
  },
});

listenerMiddleware.startListening({
  actionCreator: setSupportFiltersAction,
  effect: (action) => {
    sessionStorage.setItem(
      EStorageKeys.MESSAGE_MATCHERS_FILTERS_SUPPORT,
      JSON.stringify(action.payload),
    );
  },
});

export default messageMatchersSlice.reducer;
